import { EAppointmentStateValues, EAppointmentState } from '../../../enums/EAppointmentState';

export interface StatusInfo {
  label: string;
  cssClass: string;
  /** Tag de Novarium para el estado (`<Tag className={tagClass} value={label} />`). */
  tagClass: string;
}

export function getStatusInfo(stateId: number | null): StatusInfo {
  if (!stateId) return { label: '', cssClass: '', tagClass: 'nv-tag-neutral' };

  switch (stateId) {
    case EAppointmentStateValues[EAppointmentState.SCHEDULLED]:
      return { label: 'Agendado', cssClass: 'scheduled', tagClass: 'nv-tag-neutral' };
    case EAppointmentStateValues[EAppointmentState.CONFIRMED]:
      return { label: 'Confirmado', cssClass: 'confirmed', tagClass: 'nv-tag-ok' };
    case EAppointmentStateValues[EAppointmentState.INQUEUE]:
    case EAppointmentStateValues[EAppointmentState.PENDING_ATTENTION]:
      return { label: 'En espera', cssClass: 'inqueue', tagClass: 'nv-tag-warn' };
    case EAppointmentStateValues[EAppointmentState.INATTENTION]:
    case EAppointmentStateValues[EAppointmentState.IN_OBSERVATION]:
      return { label: 'En atención', cssClass: 'inattention', tagClass: 'nv-tag-selected' };
    case EAppointmentStateValues[EAppointmentState.COMPLETED]:
      return { label: 'Atendido', cssClass: 'completed', tagClass: 'nv-tag-ok' };
    case EAppointmentStateValues[EAppointmentState.MISSED]:
      return { label: 'Ausente', cssClass: 'missed', tagClass: 'nv-tag-neutral' };
    case EAppointmentStateValues[EAppointmentState.CANCELLED_BY_PATIENT]:
    case EAppointmentStateValues[EAppointmentState.CANCELLED_PENDING_CONTACT]:
    case EAppointmentStateValues[EAppointmentState.CANCELLED_AND_NOTIFIED]:
      return { label: 'Cancelado', cssClass: 'cancelled', tagClass: 'nv-tag-neutral' };
    default:
      return { label: '', cssClass: '', tagClass: 'nv-tag-neutral' };
  }
}
